import { useEffect, useState } from "react";
import {
  Alert,
  Badge,
  Box,
  Button,
  Group,
  Modal,
  Stack,
  Text,
} from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons";

let pendingResolve = null;
let openPromptState = null;

export const CommissionRegenerationPromptBridge = ({ children }) => {
  const [promptState, setPromptState] = useState(null);

  useEffect(() => {
    openPromptState = setPromptState;
    return () => {
      openPromptState = null;
    };
  }, []);

  const close = (choice) => {
    setPromptState(null);
    if (pendingResolve) {
      const resolve = pendingResolve;
      pendingResolve = null;
      resolve(choice);
    }
  };

  return (
    <>
      {children}
      <Modal
        opened={!!promptState}
        onClose={() => close("cancel")}
        title="Commission data may change"
        size="sm"
        zIndex={1100}
        closeOnClickOutside={false}
        closeOnEscape={false}
        withCloseButton={false}
        padding="lg"
      >
        <Stack spacing="lg">
          <Alert
            icon={<IconAlertTriangle size={18} />}
            color="orange"
            variant="light"
            title="Order changes affect commission"
          >
            Saving these edits can update the commission schedule and waiting
            commission payments.
          </Alert>

          {promptState?.changes?.length > 0 && (
            <Box>
              <Text size="xs" color="dimmed" mb={8}>
                Changed fields
              </Text>
              <Group spacing={6}>
                {promptState.changes.map((change) => (
                  <Badge key={change.field} variant="light" color="cyan">
                    {change.label}
                  </Badge>
                ))}
              </Group>
            </Box>
          )}

          <Text size="xs" color="dimmed" lh={1.6}>
            Received or confirmed commission payments will not be deleted. Only
            waiting or unconfirmed payments may be recalculated.
          </Text>

          <Stack spacing="xs">
            <Button fullWidth onClick={() => close("regenerate")}>
              Save and regenerate commission
            </Button>
            <Button
              fullWidth
              variant="outline"
              onClick={() => close("skip")}
            >
              Save order only
            </Button>
            <Button
              fullWidth
              variant="subtle"
              color="gray"
              onClick={() => close("cancel")}
            >
              Cancel
            </Button>
          </Stack>
        </Stack>
      </Modal>
    </>
  );
};

export const promptCommissionRegeneration = (changes) =>
  new Promise((resolve) => {
    if (!openPromptState) {
      resolve("regenerate");
      return;
    }
    pendingResolve = resolve;
    openPromptState({ changes });
  });
